import { useNavigate, useParams } from 'react-router-dom';
import { useCreateModuleMutation } from '../useCreateModuleMutation';
import { useUpdateModuleMutation } from '../useUpdateModuleMutation';
import { QueryKeys } from 'src/core/router/constants';
import { useActiveFreeSignup } from 'src/modules/product/hooks/useActiveFreeSignup';
import { DrawerHelper } from 'src/shared/components/drawer/helper';
import { Routes } from 'src/shared/constants/routes';
import { dispatchSaveCustomEvent } from './dispatchSaveCustomEvent';
import { removeModuleQueries } from './removeModuleQueries';
export function useSubmitModule({ isUpdate, isFreeModule, onSubmitSuccess }) {
    const navigate = useNavigate();
    const { moduleId } = useParams();
    const createModuleMutation = useCreateModuleMutation();
    const updateModuleMutation = useUpdateModuleMutation(moduleId || '');
    const { activeFreeSignup, isFreeSignupModalDismissed, shouldActivateFreeSignup } = useActiveFreeSignup(isFreeModule);
    const submitMutation = isUpdate ? updateModuleMutation : createModuleMutation;
    function success({ isUpdate, moduleId, formData }) {
        removeModuleQueries(moduleId);
        dispatchSaveCustomEvent({ moduleId, isUpdate, isExtraModule: formData.extra });
        if (shouldActivateFreeSignup) {
            activeFreeSignup();
            if (!isFreeSignupModalDismissed) {
                const redirectToConfigureFreeSignup = () => {
                    navigate({
                        pathname: Routes.ListModules,
                        search: `${QueryKeys.ConfigureFreeSignup}=true`
                    });
                };
                DrawerHelper.listenerOnClose(redirectToConfigureFreeSignup);
                onSubmitSuccess();
                return;
            }
        }
        const redirectToModulesList = () => {
            navigate({
                pathname: Routes.ListModules,
                search: formData.extra ? `${QueryKeys.Extra}=true` : ''
            });
        };
        DrawerHelper.listenerOnClose(redirectToModulesList);
        onSubmitSuccess();
    }
    const submit = (formData) => {
        const { cover, ...rest } = formData;
        const payload = {
            ...rest,
            coverImageId: cover?.id ?? null,
            publicModule: formData.extra ? false : formData.publicModule
        };
        submitMutation.mutate(payload, {
            onSuccess: (data) => {
                success({
                    isUpdate,
                    moduleId: data.id || moduleId,
                    formData
                });
            }
        });
    };
    return { submit, isPending: submitMutation.isPending };
}
